import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Topo from "../Topo/topo";
import { usuariosAPI } from "../../servicos/usuarios";
import { FormField } from "../ui/form-field";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { useForm } from "react-hook-form";
import { toast } from "sonner";

function Editar() {

    const breadcrumbs = ['Admin', 'Usuário', 'Edição'];

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting },
    } = useForm({
        defaultValues: {
            us100_dsc_usuario: '',
            us100_dsc_email: '',
        },
        mode: 'onBlur',
    });

    let navigate = useNavigate();
    const Voltar = () => {
        let path = '/admin/usuario';
        navigate(path);
    }

    const { hash } = useParams();

    useEffect(() => {
        if(hash) {
            usuariosAPI.get(`/${hash}`)
                .then(resposta => {
                    reset({
                        us100_dsc_usuario: resposta?.data?.us100_dsc_usuario || '',
                        us100_dsc_email: resposta?.data?.us100_dsc_email || '',
                    });
                })
                .catch(erro => {
                    let mensagem = 'Ops! Ocorreu um erro inesperado.';
                    if (erro?.response?.data?.message) {
                        mensagem = erro.response.data.message;
                    } else if (erro.response?.status === 401) {
                        mensagem = 'Ops! Sessão Expirada! Faça um novo login.';
                    }
                    toast.error(mensagem);
                });
        }
    }, [hash, reset]);

    const onSubmit = async (values) => {
        if(!hash){
            toast.error("OPS Desconheço o cadastro deste usuário.");
            return;
        }
        try {
            await usuariosAPI.put(`/editar/${hash}`, {
                us100_dsc_usuario: values.us100_dsc_usuario,
                us100_dsc_email: values.us100_dsc_email,
            });
            toast.success('Usuário alterado com sucesso.');
        } catch (erro) {
            let mensagem = 'Ops! Ocorreu um erro inesperado.';
            if (erro?.response?.data?.message) {
                mensagem = erro.response.data.message;
            } else if (erro.response?.status === 401) {
                mensagem = 'Ops! Sessão Expirada! Faça um novo login.';
            }
            toast.error(mensagem);
        }
    };

    const onInvalidSubmit = () => {
        toast.error('Por favor, corrija os campos destacados.');
    };

    return (
        <div class="row">
            <div class="container">
                <Topo titulo='Editar Usuário' breadcrumbs={breadcrumbs} btnincluir={false} admin={true}/>
                <div class="row row-padding-conteudo">
                    <div class="col-12">
                        <form class="row gy-4 gx-4" onSubmit={handleSubmit(onSubmit, onInvalidSubmit)}>
                            <div class="col-md-6">
                                <FormField
                                    id="us100_dsc_usuario"
                                    label="Nome do Usuário"
                                    error={errors.us100_dsc_usuario?.message}
                                >
                                    <Input
                                        id="us100_dsc_usuario"
                                        {...register('us100_dsc_usuario', {
                                            required: 'Informe o nome.',
                                            minLength: {
                                                value: 3,
                                                message: 'O nome deve possuir ao menos 3 caracteres.',
                                            },
                                        })}
                                    />
                                </FormField>
                            </div>
                            <div class="col-md-6">
                                <FormField
                                    id="us100_dsc_email"
                                    label="E-mail"
                                    error={errors.us100_dsc_email?.message}
                                >
                                    <Input
                                        id="us100_dsc_email"
                                        type="email"
                                        {...register('us100_dsc_email', {
                                            required: 'Informe o e-mail.',
                                            pattern: {
                                                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                message: 'Informe um e-mail válido.',
                                            },
                                        })}
                                    />
                                </FormField>
                            </div>
                            <div class="col-12 tw-flex tw-justify-end tw-gap-3 tw-pt-2">
                                <Button type="button" variant="outline" onClick={Voltar} className="tw-min-w-[120px] tw-text-slate-700 dark:tw-text-white">
                                    Voltar
                                </Button>
                                <Button type="submit" className="tw-min-w-[140px]" disabled={isSubmitting}>
                                    {isSubmitting ? 'Salvando...' : 'Salvar'}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Editar;

